<template>
  <div
    class="wt-custom-overlays-separator"
    @click="$emit('emmiter', { name: 'toggle-expend', data: field })"
    :class="{
      '-no-label': !field.label,
      '-expendable': field.__expendable,
      '-expend': field.__expend,
    }"
  >
    <span v-if="field.label" v-text="field.label"></span>
    <slot name="tooltip"></slot>
    <i
      v-if="field.__expendable"
      :class="field.__expend ? 'rotate-up' : 'rotate-down'"
      class="wticon wticon-angle-left"
    ></i>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['label'], (prop) => _.includes(_.keys(value), prop));
      },
    },
  },

  mixins: [fieldsMixin],

  mounted() {
    this.fieldReadyNextTick();
  },
};
</script>
